// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__q8OLB","label":"Radio_label__3tmNW","checkMark":"Radio_checkMark__125_v","disabled":"Radio_disabled__1QBdo"};